export default __webpack_public_path__ + "static/media/not-found.e05fec46.png";